import rill from "rill";
import redirect from "@rill/redirect";
import set from "@rill/set";
import Settings from "./settings";
import Billing from "./billing";
import CoachBilling from "./coach-billing";
import CoachManageBilling from "./coach-manage-billing";
import ManageCoaching from "./manage-coaching";
import Notifications from "./notifications";
import Faqs from "./faqs";
import Branding from "./branding";
import StorefrontScripts from "./storefront-scripts";
import Profile from "./profile";
import Preferences from "./preferences";
import ExerciseLibrary from "./exercise-library";
import Subscription from "./subscription";
import GymContract from "./gym-contract";
import ManageCoaches from "./manage-coaches";
import GymLocations from "./gym-locations";

const SettingsController = (app) => {
  app.get("/settings", redirect("/dashboard/settings/profile")).at(
    "/settings/*",
    rill()
      .use(set("heading", ["Settings"]))
      .setup(Settings)
      .setup(Billing)
      .setup(CoachBilling)
      .setup(CoachManageBilling)
      .setup(ManageCoaches)
      .setup(ManageCoaching)
      .setup(Notifications)
      .setup(Faqs)
      .setup(Branding)
      // .setup(StorefrontScripts)
      .setup(GymContract)
      .setup(GymLocations)
      .setup(Profile)
      .setup(Preferences)
      .setup(ExerciseLibrary)
      .setup(Subscription)
  );
};

export default SettingsController;
